import { render, staticRenderFns } from "./Pickup.vue?vue&type=template&id=74affc82&scoped=true"
import script from "./Pickup.vue?vue&type=script&lang=js"
export * from "./Pickup.vue?vue&type=script&lang=js"
import style0 from "./Pickup.vue?vue&type=style&index=0&id=74affc82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74affc82",
  null
  
)

export default component.exports